import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowRight } from "feather-icons-react/build/IconComponents";
import { setServiceValue } from "../../../core/redux/action";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, useParams } from "react-router-dom";
// import { Link, useParams } from "react-router-dom";
import apiHandler from "../../common/api";
import Swal from "sweetalert2";
import AddService from "./AddService";
import { all_routes } from "../../../Router/all_routes";
import { ServiceInitialData } from "../../../core/json/service_initial_Data";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

const ManageService = ({ isDisable = false }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const user_data = useSelector((state) => state.user_data);
  const formValue = useSelector((state) => state.ServiceValue);
  console.log(user_data, "410501TeamValue");
  const MySwal = withReactContent(Swal);
  const route = all_routes;
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);
  const [uploadImage, setUploadImage] = useState(null)

  console.log(route, "route123");

  console.log(params, "params1 23 45");

  console.log(uploadImage, "uploadImage check");

  const HandleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (
      formValue?.serviceName == "" ||
      formValue?.serviceType == 0 ||
      formValue?.menuCategoryID == 0
    ) {
      let message = "";
      if (formValue?.serviceName == "") {
        message = " Please Enter Service name ";
      } else if (formValue?.serviceType == 0) {
        message = " Please select Service Type  ";
      } else if (formValue?.menuCategoryID == 0) {
        message = " Please select Service Menu  ";
      }

      Swal.fire({
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    let priceDuration = formValue?.Pricingandduration?.filter(
      (el) => el.Price > 0
    );

    let TeamDatavalue = formValue?.Team?.filter((el) => el.Ischecked == true);

    let priceDurationData = {};
    priceDurationData.PricinganddurationXml = priceDuration;
    let priceDurationDataString = JSON.stringify(priceDurationData);

    let TeamData = {};
    TeamData.TeamXml = TeamDatavalue;
    let TeamDataString = JSON.stringify(TeamData);

    console.log(formValue, "check form")

    const response = await apiHandler({
      method: "POST",
      route: "Business/businessServiceUpsert",
      payload: {
        ...formValue,
        BusinessId: user_data.businessId,
        loginuserid: user_data.id,
        Pricingandduration: priceDurationDataString,
        Team: TeamDataString,
        files: uploadImage,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.ResponseCode === "SUCCESS") {

      const ResponseID = response?.ResponseID[0]?.ID
      const Message = response?.ResponseID[0]?.Message

      console.log(ResponseID, Message)
      setLoading(false);
      if (ResponseID > 0){
        MySwal.fire({
          // title: "Upsert!",
          // text: "Your file has been Upsert.",
          title: params.ID > 0 ? "Service Updated!" : "Service Added!",
          text: params.ID > 0 ? "The Service details have been successfully updated." : "The Service has been successfully added.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(setServiceValue(ServiceInitialData));
            navigate(route.ServiceList);
          }
        });
      } 
      else {
      MySwal.fire({
        icon: "warning",
        title: "Duplicate Service Name",
        html: `${Message}`,
        confirmButtonText: "OK",
        confirmButtonColor: "#f8bb86", // optional: yellowish tone
        customClass: {
          confirmButton: "btn btn-warning", // your existing button style
        },
      });}

    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `${response.ResponseMessage}`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const fetchServiceData = async () => {
    try {
      const serviceData = await apiHandler({
        method: "GET",
        route: `Superadmin/TeamListbybusinessId?businessId=${user_data?.businessId}`,
      });

      if (serviceData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", serviceData);
        return;
      }

      let Teamdata = serviceData?.ResponseData?.map((el) => ({
        Name: el.fullName,
        Ischecked: true,
        ID: el.id,
        serviceTeamID: 0,
      }));

      if (params.ID > 0) {
        await dispatch(
          setServiceValue({
            ...formValue,
            Team: Teamdata,
            Count: serviceData?.ResponseData?.length || 0,
          })
        );
      } else {
        await dispatch(
          setServiceValue({
            ...ServiceInitialData,
            Team: Teamdata,
            Count: serviceData?.ResponseData?.length || 0,
          })
        );
      }

      if (params.ID > 0) {
        const findByIdResponse = await apiHandler({
          method: "GET",
          route: `Business/servicefindbyID?ID=${params.ID}`,
        });

        if (findByIdResponse?.ResponseCode !== "SUCCESS") {
          console.error("Failed to fetch service details:", findByIdResponse);
          return;
        }

        const basicDetails =
          findByIdResponse?.ResponseData?.BasicDetiles?.[0] || {};
        const pricingAndDuration =
          findByIdResponse?.ResponseData?.Pricingandduration || [];
        const teamData = findByIdResponse?.ResponseData?.Team || [];

        let teamMap = {};
        teamData.forEach((team) => {
          teamMap[team?.ID] = team?.serviceTeamID;
        });

        let Teamdata = serviceData?.ResponseData?.map((el) => ({
          Name: el.fullName,
          ID: el.id,
          Ischecked: teamMap[el.id] > 0,
          serviceTeamID: teamMap[el.id] || 0,
        }));

        console.log(formValue.Team, "newTeam");

        const updatedServiceValue = {
          serviceName: basicDetails?.serviceName,
          serviceType: basicDetails?.serviceType,
          menuCategoryID: basicDetails?.menuCategoryID,
          serviceDescription: basicDetails?.serviceDescription,
          isThisHomeService: basicDetails?.isThisHomeService || 0,
          isThisComboService: basicDetails?.isThisComboService || 0,
          comboServiceIds: basicDetails?.comboServiceIds || "",
          ID: basicDetails?.ID,
          Pricingandduration: pricingAndDuration.map((el) => ({
            minDuration: el.minDuration,
            maxDuration: el.duration,
            Pricetype: el.priceType,
            Price: el.price,
            PricinganddurationID: el.PricinganddurationID,
          })),
          Team: Teamdata,
          serviceLogo: basicDetails?.serviceLogo
        };
        dispatch(setServiceValue(updatedServiceValue));
      }
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  useEffect(() => {
    fetchServiceData();
  }, [params?.ID]);

  return (
    <>
     <LoadingSpinner isLoading={loading} />
    <div>
      <AddService isDisable={isDisable} setUploadImage={setUploadImage}/>
      <div className="pt-0 page-wrapper">
        <div className="content">
          {/* <div className="row page-header justify-content-between">
            <div className="col-md-6"></div>
          </div> */}
          {/* Moved buttons to the end of .content */}
          {isDisable == false && (
            <div className="d-flex justify-content-end mb-4">
              <button className="btn btn-outline-primary btn-sm me-2">
                Cancel
              </button>
              <button
             
                onClick={HandleSubmit}
                className="8 btn btn-primary btn-md btn-wave me-2 "
              >
                Save
                <ArrowRight />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
    </>
  );
};
export default ManageService;
